
import React from "react";
import "./CementDetails.css"

const CementDetails = () => {
  return (
     <div className="ldh-cemt-section">
        <h2>Cement</h2>
      <h3>What is Cement?</h3>
      <p>
        Cement is a binding material that, when mixed with water, sets and
        hardens to bind sand and aggregates in construction.
      </p>

      <h3>Cement Grades & Uses</h3>

      <p>
        <strong>OPC 43:</strong> General construction, masonry, plastering and
        RCC work.
      </p>

      <p>
        <strong>OPC 53:</strong> RCC, precast, bridges and applications
        requiring higher early strength.
      </p>

      <p>
        <strong>PPC:</strong> Buildings, foundations, plastering and general
        construction, with good durability.
      </p>

      <p>
        <strong>PSC:</strong> Infrastructure, foundations, bridges and suitable
        aggressive environments.
      </p>

      <h3>How to Choose?</h3>

      <p>
        Choose cement based on construction type, required strength, exposure
        conditions and project specifications.
      </p>
    </div>
  );
};

export default CementDetails;

